export * from './login.component';


// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/login/index.ts